export const intlMessagesId = {
  'account.email.unverified.message': 'Mohon periksa tautan verifikasi yang kami kirimkan ke email kamu',
  'account.email.unverified.resend.verification.button': 'Kirim ulang',
  'account.email.unverified.title': 'Verifikasi Email',
  'account.email.unverified.update.email.button': 'Ubah email',

  'account.email.update.continue': 'Ubah',
  'account.email.update.email': 'Email',
  'account.email.update.password': 'Password',
  'account.email.update.title': 'Ubah Email',

  'account.forgot.password.continue': 'Kirim',
  'account.forgot.password.title': 'Lupa Password',
  'account.forgot.password.username': 'Email / No. Handphone',

  'account.getstarted.go.to.dashboard': 'Lanjut Dashboard',
  'account.getstarted.invoice.content': 'Terima pembayaran dengan mudah menggunakan invoice.',
  'account.getstarted.invoice.subtitle': ' . untuk penjual',
  'account.getstarted.invoice.title': 'Invoice',
  'account.getstarted.main.content': 'Berikut fitur transaksi yang paling sering digunakan oleh user lain.',
  'account.getstarted.transfer.content': 'Kirim uang ke nomor telepon dengan cepat.',
  'account.getstarted.transfer.title': 'Transfer',
  'account.getstarted.welcome': 'Selamat Datang!',

  'account.kyc.finish.button': 'OK',
  'account.kyc.finish.info': 'Data kamu saat ini sedang masuk dalam antrian verifikasi.<br/><br/>Agen kami akan menghubungi Kamu untuk proses lebih lanjut.',
  'account.kyc.finish.subtitle': 'Terima kasih',
  'account.kyc.finish.title': 'Kaspay Pro',

  'account.kyc.form.address': 'Alamat sesuai identitas',
  'account.kyc.form.birthDate': 'Tanggal lahir',
  'account.kyc.form.birthPlace': 'Tempat lahir',
  'account.kyc.form.button': 'Lanjut',
  'account.kyc.form.motherName': 'Nama ibu kandung',
  'account.kyc.form.name': 'Nama Lengkap',
  'account.kyc.form.nationalCardNumber': 'No. KTP / SIM',

  'account.kyc.overview.feature.invoice.text': 'Unlimited invoice',
  'account.kyc.overview.feature.max.balance': 'Rp 10jt',
  'account.kyc.overview.feature.max.balance.text': 'Saldo maks. {amount}',
  'account.kyc.overview.feature.max.money.in': 'Rp 20jt',
  'account.kyc.overview.feature.max.money.in.text': 'Jumlah transaksi {amount}',
  'account.kyc.overview.feature.transfer.text': 'Aktifkan fitur Transfer',
  'account.kyc.overview.message': 'Dapatkan keuntungan menjadi Kaspay Pro secara GRATIS',
  'account.kyc.overview.notice': '*Persiapkan scan KTP/SIM & foto diri',
  'account.kyc.overview.title': 'Kaspay Pro',
  'account.kyc.overview.upgrade.button': 'Upgrade ke Kaspay Pro',

  'account.kyc.register.title': 'Daftar Kaspay Pro',

  'account.kyc.uploadDocument.button': 'Selesai',
  'account.kyc.uploadDocument.nationalCardScan': 'Upload kartu identitas (KTP/SIM)',
  'account.kyc.uploadDocument.nationalCardSelfie': 'Upload foto diri memegang kartu identitas',
  'account.kyc.uploadDocument.subtitle': 'Sertakan scan kartu identitas anda (KTP / SIM) dan foto diri memegang kartu identitas',
  'account.kyc.uploadDocument.title': 'Upload Dokumen',

  'account.kyc.verification.success.benefit.message': 'Kini Kamu bisa menggunakan semua manfaat ini',
  'account.kyc.verification.success.button': 'OK',
  'account.kyc.verification.success.title': 'Kaspay Pro',
  'account.kyc.verification.success.verified.message': 'Data Kamu telah selesai diverifikasi',
  'account.kyc.verification.success.welcome.message': 'Selamat bergabung di Kaspay Pro!',

  'account.kyc.waiting.notice': '*Proses review bisa sampai 5 hari kerja',
  'account.kyc.waiting.ok.button': 'OK',
  'account.kyc.waiting.please.wait': 'Harap Menunggu',
  'account.kyc.waiting.title': 'Menunggu Verifikasi',
  'account.kyc.waiting.verification.notification': 'Agen kami akan menghubungi Kamu untuk proses lebih lanjut',
  'account.kyc.waiting.verification.queue': 'Data kamu saat ini sedang masuk dalam antrian verifikasi',

  'account.login.continue': 'Masuk',
  'account.login.forgot.password': 'Lupa Password',
  'account.login.link': 'Login',
  'account.login.password': 'Password',
  'account.login.register': 'Daftar',
  'account.login.register.pre': 'Belum punya akun?',
  'account.login.title': 'Masuk',
  'account.login.username': 'Email / No. Handphone',

  'account.password.update.continue': 'Ubah',
  'account.password.update.newPassword': 'Password baru',
  'account.password.update.oldPassword': 'Password lama',
  'account.password.update.title': 'Ubah Password',

  'account.phone.set.continue': 'Lanjut',
  'account.phone.set.info': 'Nomor handphone dibutuhkan untuk keamanan transaksi kamu.',
  'account.phone.set.phonenumber': 'Nomor handphone',
  'account.phone.set.title': 'No. Handphone',

  'account.profile.email': 'Email',
  'account.profile.email.verify': 'Verifikasi',
  'account.profile.email.verify.footnote': 'Klik di sini untuk verifikasi email Kamu',
  'account.profile.get.kaspay.pro': 'Dapatkan fitur-fitur Kaspay Pro secara gratis hanya dengan melengkapi profil',
  'account.profile.kaspay.pro': 'Kaspay Pro',
  'account.profile.password': 'Password',
  'account.profile.phonenumber': 'Nomor Handphone',
  'account.profile.phonenumber.change.contact.us': 'hubungi kami.',
  'account.profile.phonenumber.change.message': 'Nomor handphone tidak dapat diubah secara langsung, untuk mengubah nomor handphone, email ke support@kaspay.com atau ',
  'account.profile.see.more.button': 'Lihat selengkapnya',
  'account.profile.store': 'Toko saya',
  'account.profile.title': 'Profil & Pengaturan',
  'account.profile.update.address': 'Lokasi',
  'account.profile.update.address.footnote': 'Cth: Jakarta, Bandung, Surabaya',
  'account.profile.update.button': 'Simpan',
  'account.profile.update.name': 'Nama lengkap',
  'account.profile.update.title': 'Ubah Profil',

  'account.register.agreement.final': 'Kaspay.',
  'account.register.agreement.info': 'Dengan menekan Daftar, saya mengkonfirmasi telah menyetujui',
  'account.register.agreement.link': 'Syarat dan Ketentuan',
  'account.register.continue': 'Daftar',
  'account.register.email': 'Email',
  'account.register.login': 'Masuk',
  'account.register.login.pre': 'Sudah punya akun?',
  'account.register.password': 'Password',
  'account.register.phone': 'Nomor handphone',
  'account.register.title': 'Buat Akun Kaspay',

  'account.store.form.address': 'Lokasi',
  'account.store.form.address.format': 'Cth: Jakarta, Bandung, Surabaya',
  'account.store.form.button': 'Simpan',
  'account.store.form.name': 'Nama Toko',
  'account.store.form.title': 'Informasi Toko',
  'account.store.form.upload.image.button': 'Upload gambar',
  'account.store.form.url': 'Link Media Sosial (opsional)',
  'account.store.form.url.format': 'Cth: instagram.com/toko-saya',

  'account.store.register.message': 'Sebelum menggunakan fitur Invoice, silakan masukkan informasi toko Anda',

  'account.wallet.get.failed': 'Saldo gagal diupdate',

  'action.failed.account.email.update': 'Gagal mengganti email',
  'action.failed.account.forgot.password': 'Gagal menjalankan lupa password',
  'action.failed.account.login': 'Username atau password salah',
  'action.failed.account.password.update': 'Gagal mengganti password',
  'action.failed.account.profile.update': 'Gagal menyimpan profil',
  'action.failed.account.register': 'Gagal registrasi akun Kaspay',
  'action.failed.account.validate.set.phonenumber': 'Gagal validasi set nomor handphone',
  'action.failed.invoice': 'Gagal memproses invoice',
  'action.failed.invoice.create': 'Gagal membuat invoice',
  'action.failed.invoice.load': 'Gagal menampilkan invoice',
  'action.failed.invoice.query': 'Gagal menampilkan daftar invoice',
  'action.failed.invoice.remove': 'Gagal menghapus invoice',
  'action.failed.invoice.update': 'Gagal mengganti invoice',
  'action.failed.landing.send.business.data': 'Gagal mengirimkan data Anda',
  'action.failed.otp.confirm': 'Gagal melakukan validasi kode verifikasi',
  'action.failed.otp.request': 'Permintaan kode verifikasi gagal',
  'action.failed.profile.register': 'Gagal registrasi data diri',
  'action.failed.profile.upload.nationalCardScan': 'Gagal mengunggah gambar KTP/SIM',
  'action.failed.profile.upload.nationalCardSelfie': 'Gagal mengunggah gambar foto diri memegang kartu identitas',
  'action.failed.store.register': 'Gagal registrasi toko',
  'action.failed.store.update': 'Gagal menyimpan informasi toko',
  'action.failed.store.upload.avatar': 'Gagal mengunggah gambar avatar toko',
  'action.failed.verification.forgot.password.by.email': 'Verifikasi lupa password gagal',
  'action.failed.wallet.get.account': 'Saldo gagal diupdate',
  'action.failed.wallet.get.transactionSummary': 'Rangkuman transaksi gagal diupdate',
  'action.failed.wallet.load.more.history': 'Gagal mendapatkan list transaksi',
  'action.failed.wallet.redeem': 'Redeem gagal',
  'action.failed.wallet.redeem.history': 'Gagal mendapat history transaksi',
  'action.failed.wallet.topUp': 'Permintaan isi Saldo Kaspay gagal',
  'action.failed.wallet.topUp.invalidAmount': 'Jumlah harus antara {minAmount} dan {maxAmount}',
  'action.failed.wallet.transfer': 'Transfer gagal',

  'action.success.account.email.update': 'Link verifikasi sudah dikirimkan ke email pengganti yang ingin kamu gunakan',
  'action.success.account.forgot.password.verification.email.sent': 'Link verifikasi sudah dikirimkan ke email Anda',
  'action.success.account.password.update': 'Berhasil mengganti password',
  'action.success.account.profile.update': 'Profil berhasil disimpan',
  'action.success.invoice.delete': 'Invoice berhasil dihapus',
  'action.success.invoice.link.copied': 'Copied',
  'action.success.landing.send.business.data': 'Data Anda telah kami terima',
  'action.success.otp.account.phone.setnumber': 'Berhasil set nomor handphone',
  'action.success.otp.confirm.account.register': 'Registrasi akun Kaspay berhasil, silakan cek email kamu untuk verifikasi',
  'action.success.otp.confirm.forgot.password': 'Silakan login menggunakan password baru anda',
  'action.success.otp.request': 'Kode verifikasi berhasil kami kirimkan',
  'action.success.store.update': 'Informasi toko berhasil disimpan',
  'action.success.verification.forgot.password.by.email': 'Verifikasi lupa password berhasil',

  'checkout.error.caption': 'Harap hubungi seller terkait',
  'checkout.error.title': 'Link Tidak Ditemukan',
  'checkout.preview.invoice': 'Invoice',
  'checkout.preview.pay': 'Bayar Sekarang',

  'error.account.is.not.registered': 'Akun dengan Email / No. Handphone ini tidak terdaftar',
  'error.email.already.exist': 'Email ini sudah digunakan oleh akun lain',
  'error.entity.not.found': 'Akun dengan Email / No. Handphone ini tidak terdaftar',
  'error.invalid.request': 'Permintaan tidak dapat dipenuhi',
  'error.invoice.entity.not.found': 'Invoice tidak dapat ditemukan',
  'error.invoice.operation.error': 'Gagal melakukan operasi invoice',
  'error.otp.expired': 'Kode verifikasi sudah tidak berlaku',
  'error.otp.max.resend.reached': 'Kamu sudah melebihi jumlah resend kode verifikasi yang diperbolehkan',
  'error.otp.max.wrong.reached': 'Kamu memasukkan kode yang salah lebih dari jumlah yang diperbolehkan',
  'error.otp.mismatch': 'Kode yang kamu masukkan salah',
  'error.otp.sent.failed': 'Gagal mengirimkan kode verifikasi',
  'error.password.mismatch': 'Password lama tidak sesuai',
  'error.phone.already.exist': 'No. Handphone ini sudah digunakan oleh akun lain',
  'error.phone.already.set': 'Akun ini sudah terdaftar dengan nomor handphone',
  'error.send.email.failed': 'Gagal mengirimkan email verifikasi',
  'error.size.limit.exceeded': 'Ukuran file gambar harus < 4 MB',

  'footer.copyright': 'Copyright &copy; 2017 Kaspay',
  'footer.faq': 'FAQ',
  'footer.kaspay': 'Kaspay',
  'footer.term': 'Syarat dan Ketentuan',
  'footer.term.info': 'Dengan menekan Lanjut, saya mengkonfirmasi telah menyetujui',

  'form.error.image.size.limit.exceeded': 'Ukuran file gambar harus < 4 MB',
  'form.error.invalid.birthDate.format': 'Format tanggal lahir tidak valid',
  'form.error.invalid.email.format': 'Alamat email tidak valid',
  'form.error.invalid.password.format': 'Password harus mengandung angka dan huruf, min. 6 karakter',
  'form.error.invalid.phone.format': 'Nomor handphone tidak valid',
  'form.error.invalid.phone.self': 'Tidak dapat melakukan transfer ke nomor sendiri',
  'form.error.invalid.url.format': 'URL tidak valid',
  'form.error.invalid.username.format': 'Email / No. Handphone tidak valid',
  'form.error.required': 'Kolom ini wajib diisi',
  'form.footnote.otp.info': 'SMS dengan kode verifikasi akan dikirim ke nomor handphone kamu.',
  'form.footnote.upload.limit.info': 'Maks. {sizeInMb}Mb',
  'form.footnote.valid.password.format': 'Kombinasi angka dan huruf, min. 6 karakter',
  'form.upload.button': 'Upload',

  'invoice.create.title': 'Buat Invoice',

  'invoice.detail.confirmation.info': 'Invoice anda akan dihapus secara permanen',
  'invoice.detail.confirmation.no': 'Tidak',
  'invoice.detail.confirmation.title': 'Apakah anda yakin?',
  'invoice.detail.confirmation.yes': 'Ya',
  'invoice.detail.delete': 'Hapus',
  'invoice.detail.edit': 'Ubah',

  'invoice.error.balance.over.limit.message': 'Limit saldo yang dapat tersimpan di akun kamu <b>maks. {amount}</b>',
  'invoice.error.button': 'Tutup',
  'invoice.error.caption': 'Harap hubungi seller terkait',
  'invoice.error.currency': 'Rp',
  'invoice.error.failed': 'Gagal',
  'invoice.error.invoice.created.over.limit' : 'Pembuatan invoice sudah melewati batas <b>maksimum 3 invoice</b>',
  'invoice.error.limit.label': 'Limit Invoice',
  'invoice.error.money.in.per.month.over.limit.message': 'Limit transaksi bulanan yang dapat masuk ke akun kamu <b>maks. {amount}</b>',
  'invoice.error.title': 'Link Tidak Ditemukan',
  'invoice.error.total.balance': 'Total saldo',
  'invoice.error.total.money.in.per.month': 'Total transaksi bulanan',
  'invoice.error.upgrade': 'Untuk memiliki saldo lebih, silakan upgrade ke <b>Kaspay Pro</b>',

  'invoice.form.buyer': 'Data Pemesan',
  'invoice.form.buyer.name': 'Nama pemesan',
  'invoice.form.buyer.phone': 'Nomor handphone',
  'invoice.form.continue': 'Lanjut',
  'invoice.item.form.name': 'Deskripsi Pesanan',
  'invoice.item.form.price': 'Total Pembayaran',

  'invoice.onboarding.button.label': 'Mulai',
  'invoice.onboarding.free.description': 'Bebas biaya selama periode promo.',
  'invoice.onboarding.free.title': 'Promo Tanpa Biaya',
  'invoice.onboarding.invoice.description': 'Buat tagihan pembayaran & kirimkan linknya ke pelanggan. Mudah dan Cepat.',
  'invoice.onboarding.invoice.title': 'Invoice',
  'invoice.onboarding.store.description': 'Daftarkan toko online kamu untuk membuat tagihan pembayaran.',
  'invoice.onboarding.store.title': 'Daftar Toko',

  'invoice.page.empty': 'Tekan + untuk membuat invoice baru',
  'invoice.page.empty.all': 'Belum ada Invoice',
  'invoice.page.empty.paid': 'Belum ada Invoice',
  'invoice.page.empty.pending': 'Belum ada Invoice',
  'invoice.page.limit.warning.suggestion': 'Upgrade ke <b>{walletAccountType}</b> untuk membuat invoice tanpa batas',
  'invoice.page.limit.warning.title': 'Maksimal 3 Invoice',
  'invoice.page.limit.warning.upgrade': 'Upgrade',
  'invoice.page.shop.placeholder': 'Toko (max 20 char)',
  'invoice.page.tab.all': 'Semua',
  'invoice.page.tab.paid': 'Paid',
  'invoice.page.tab.pending': 'Pending',

  'invoice.title': 'Invoice',
  'invoice.update.title': 'Ubah Invoice',

  'kaspay.location': 'Jakarta, Indonesia',

  'landing.business.form.continue': 'Kirim',
  'landing.business.form.email': 'Email',
  'landing.business.form.name': 'Nama',
  'landing.business.form.subhead': 'Kirimkan email Anda untuk mengetahui lebih lanjut bagaimana Kaspay dapat membantu bisnis Anda',
  'landing.business.form.title': 'Kaspay untuk Bisnis',
  'landing.business.title': 'Kaspay untuk Bisnis',
  'landing.buy.subhead': 'Beli pulsa dan paket data, langsung dari smartphone kamu',
  'landing.buy.title': 'Beli',
  'landing.daftar.sekarang': 'Daftar Sekarang',
  'landing.info.selengkapnya': 'Info selengkapnya',
  'landing.link.support.title': 'Bantuan',
  'landing.masuk': 'Masuk',
  'landing.messenger.subhead': 'Temukan Kaspay di chatting platform favoritmu!',
  'landing.messenger.title': 'Available on',
  'landing.partner.title': 'Partners',
  'landing.receive.subhead': 'Terima pembayaran secara online dengan mudah melalui fitur Invoicing. Cukup berikan permintaan pembayaran anda kepada pelanggan menggunakan link untuk memulai transaksi secara online',
  'landing.receive.title': 'Terima',
  'landing.selengkapnya': 'Selengkapnya',
  'landing.subtitle': 'Kaspay merupakan solusi pembayaran untuk memaksimalkan aktivitas transaksi individual hingga bisnis. Dengan Kaspay, semua transaksi keuangan berada dalam genggaman.',
  'landing.title': 'Simple and Secure',
  'landing.transfer.subhead': 'Mengirim uang secara online dengan mudah dan gratis antar akun Kaspay. Transfer, pembayaran, dan pencairan dana kapan saja dan dimana saja',
  'landing.transfer.title': 'Kirim',
  'landing.why.convenient.description': 'Transaksi kapanpun dan dimanapun tanpa harus pergi ke ATM',
  'landing.why.convenient.title': 'Mudah',
  'landing.why.easy.description': 'Lakukan semua transaksi keuanganmu cukup dengan beberapa klik melalui handphone',
  'landing.why.easy.title': 'Cepat',
  'landing.why.secure.description': 'Menggunakan teknologi terbaru yang menjamin keamanan transaksi',
  'landing.why.secure.title': 'Aman',
  'landing.why.title': 'Kenapa memilih Kaspay?',
  'landing.why.trusted.description': 'Lebih dari 100.000 pengguna dan 8 tahun melayani konsumen, Kaspay terus berusaha meningkatkan kualitas layanan.',
  'landing.why.trusted.title': 'Terpercaya',

  'menu.account': 'Akun',
  'menu.business': 'Bisnis',
  'menu.contactUs': 'Hubungi Kami',
  'menu.email.update': 'Ubah Email',
  'menu.faq': 'FAQ',
  'menu.home': 'Beranda',
  'menu.invoice': 'Invoice',
  'menu.login': 'Log in',
  'menu.logout': 'Log out',
  'menu.password.update': 'Ubah Password',
  'menu.profile.settings': 'Profil & Pengaturan',
  'menu.profile.settings.info': 'Upgrade ke Kaspay Pro',
  'menu.register': 'Daftar',
  'menu.service': 'Layanan',
  'menu.term': 'Syarat Dan Ketentuan',

  'otp.forgot.password.new.password': 'Password baru',

  'otp.page.confirmation.info': 'Kamu akan mengulangi verifikasi kode dari awal!',
  'otp.page.confirmation.no': 'Tidak',
  'otp.page.confirmation.title': 'Keluar verifikasi?',
  'otp.page.confirmation.yes': 'Ya',
  'otp.page.continue': 'Kirim',
  'otp.page.info': 'Masukkan 6 digit angka yang telah dikirimkan melalui SMS',
  'otp.page.resend': 'Kirim ulang kode',
  'otp.page.title': 'Kode Verifikasi',

  'statement.buyer': 'Pemesan',
  'statement.date': 'Tanggal Invoice',
  'statement.description': 'Deskripsi Pesanan',
  'statement.id': 'Invoice ID',
  'statement.invoice': 'Invoice',
  'statement.status.paid': 'Paid',
  'statement.status.pending': 'Pending',
  'statement.store': 'Toko',
  'statement.total': 'Total',

  'static.contactUs.title': 'Hubungi Kami',
  'static.faq.title': 'Frequently Asked Questions',
  'static.term.title': 'Terms & Condition',

  'verification.email.address.go.to.dashboard': 'Lanjut Dashboard',
  'verification.email.address.go.to.login': 'Lanjut Login',
  'verification.email.address.subtitle': 'Alamat email Anda sudah berhasil terverifikasi!',
  'verification.email.address.title': 'Terima kasih!',

  'verification.forgot.password.by.email.continue': 'Lanjut',
  'verification.forgot.password.by.email.newPassword': 'Password baru',
  'verification.forgot.password.by.email.title': 'Lupa Password',

  'wallet.accountTypeId.lite': 'Kaspay Lite',
  'wallet.accountTypeId.pro': 'Kaspay Pro',
  'wallet.dashboard.balance': 'Saldo <b>{amount}</b>',
  'wallet.dashboard.redeem.button': 'Transfer ke Bank',
  'wallet.dashboard.status.close': 'Selengkapnya',
  'wallet.dashboard.status.open': 'Sembunyikan',
  'wallet.dashboard.status.text.balance': 'Saldo',
  'wallet.dashboard.status.text.limit': 'Limit {amount}',
  'wallet.dashboard.status.text.transaction': 'Transaksi',
  'wallet.dashboard.topUp.button': 'Isi Saldo',
  'wallet.dashboard.transfer.button': 'Transfer ke Teman',
  'wallet.dashboard.upgrade.info': 'Upgrade',
  'wallet.history.empty': 'Belum ada mutasi',
  'wallet.history.item.redeem.subject': 'Transfer ke {bankName} ({redeemStatus})',
  'wallet.history.loadMore.button' : 'Tampilkan Lebih Banyak',
  'wallet.history.title' : 'Mutasi',
  'wallet.redeem.account.add' : '+ Rekening Lainnya',
  'wallet.redeem.account.add.button' : 'Lanjut',

  'wallet.redeem.amount.balance' : 'Saldo',
  'wallet.redeem.amount.button' : 'Transfer',
  'wallet.redeem.finish.button' : 'Tutup',
  'wallet.redeem.finish.pending' : 'Pending',
  'wallet.redeem.finish.pending.message.duration' : '3x24 jam kerja',
  'wallet.redeem.finish.pending.message.label' : 'Transaksi akan diproses maks. <b>3x24 jam kerja</b>',
  'wallet.redeem.finish.rejected' : 'Ditolak',
  'wallet.redeem.finish.success' : 'Berhasil',
  'wallet.redeem.finish.transfer' : 'Transfer',
  'wallet.redeem.form.amount' : 'Jumlah transfer',
  'wallet.redeem.form.amount.format' : 'Minimal Transfer Rp. 10.000',
  'wallet.redeem.form.amount.insufficient' : 'Saldo tidak cukup',
  'wallet.redeem.form.bankAccountName' : 'A.n. Pemilik Rekening',
  'wallet.redeem.form.bankAccountNumber' : 'Nomor Rekening',
  'wallet.redeem.form.bankName' : 'Nama Bank',
  'wallet.redeem.form.bankName.empty': 'Bank tidak ditemukan',
  'wallet.redeem.otp.amount': 'Jumlah Transfer',
  'wallet.redeem.otp.destination': 'Rekening Tujuan',
  'wallet.redeem.title' : 'Transfer ke Bank',
  'wallet.topUp.amount': 'Jumlah saldo',
  'wallet.topUp.continue': 'Lanjut',
  'wallet.topUp.error.balance.over.limit.message': 'Limit saldo yang dapat tersimpan di akun kamu <b>maks. {amount}</b>',
  'wallet.topUp.error.button': 'Tutup',
  'wallet.topUp.error.currency': 'Rp',
  'wallet.topUp.error.failed': 'Gagal',
  'wallet.topUp.error.money.in.per.month.over.limit.message': 'Limit transaksi bulanan yang dapat masuk ke akun kamu <b>maks. {amount}</b>',
  'wallet.topUp.error.topUp.limit.label': 'Limit Isi Saldo',
  'wallet.topUp.error.total.balance': 'Total saldo',
  'wallet.topUp.error.total.money.in.per.month': 'Total transaksi bulanan',
  'wallet.topUp.error.upgrade': 'Untuk memiliki saldo lebih, silakan upgrade ke <b>Kaspay Pro</b>',
  'wallet.topUp.title': 'Isi Saldo Kaspay',
  'wallet.transfer.amount.balance' : 'Saldo',
  'wallet.transfer.amount.button' : 'Transfer',
  'wallet.transfer.finish.balance.over.limit': 'Mohon maaf, transaksi ini tidak bisa di proses karena {boldText} sudah mencapai batas maksimum',
  'wallet.transfer.finish.balance.over.limit.bold.text': 'Saldo Kaspay penerima',
  'wallet.transfer.finish.button' : 'Tutup',
  'wallet.transfer.finish.money.in.monthly.over.limit': 'Mohon maaf, transaksi ini tidak bisa di proses karena {boldText} sudah mencapai batas maksimum bulanan',
  'wallet.transfer.finish.money.in.monthly.over.limit.bold.text': 'nilai transaksi penerima',
  'wallet.transfer.finish.rejected': 'Ditolak',
  'wallet.transfer.finish.success' : 'Berhasil',
  'wallet.transfer.finish.transfer' : 'Transfer',
  'wallet.transfer.form.amount' : 'Jumlah transfer',
  'wallet.transfer.form.amount.format' : 'Minimal Transfer Rp. 5.000',
  'wallet.transfer.form.amount.insufficient' : 'Saldo tidak cukup',
  'wallet.transfer.form.phone': 'Nomor Handphone',
  'wallet.transfer.otp.amount': 'Jumlah Transfer',
  'wallet.transfer.otp.destination': 'Nomor Handphone Tujuan',
  'wallet.transfer.phone.button': 'Lanjut',
  'wallet.transfer.qrCode.invalidData': 'QR Code tidak dapat diproses',
  'wallet.transfer.qrCode.submit': 'Upload QR Code',
  'wallet.transfer.title' : 'Transfer ke Teman'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/locale/id.ts